function CustomCell(_ref) {
  var component = _ref.component;
  return component;
}
export default CustomCell;